<template>
  <div>
    <!-- 待办流程 -->
    <Card style="border-left:10px solid #5cadff" v-show="!viewComponent">
      <Row type="flex">
        <Col span="3">
          <h3>待办流程</h3>
        </Col>
        <Col span="2" style="text-align:center">
          <span class="project" @click="click('npform2', 'todo')">
            <Badge :count="projectCount">
              <img src="/img/icons/立项确认.png" class="image">
              <h5 style="margin-top:12px">立项确认</h5>
            </Badge>
          </span>
        </Col>
        <Col span="2" style="text-align:center">
          <span class="project" @click="click('auditingFile', 'todo')">
            <Badge :count="fileCount">
              <img src="/img/icons/文件审核.png" class="image">
              <h5 style="margin-top:12px">文件审核</h5>
            </Badge>
          </span>
        </Col>
        <Col span="2" style="text-align:center">
          <span class="project" @click="click('depositApplyFlow', 'todo')">
            <Badge :count="depositCount">
              <img src="/img/icons/退保申请.png" class="image">
              <h5 style="margin-top:12px">退保证金</h5>
            </Badge>
          </span>
        </Col>
        <Col span="2" style="text-align:center" v-show="editPermission">
          <span class="project" @click="click('militaryExamine', 'todo')">
            <Badge :count="secretCount">
              <img src="/img/icons/保密办审核.png" class="image">
              <h5 style="margin-top:12px">保密办审核</h5>
            </Badge>
          </span>
        </Col>
        <Col span="2" style="text-align:center" v-show="hasCommission">
          <span class="project" @click="click('declare', 'todo', 'QR')">
            <Badge :count="QRCount">
              <img src="/img/icons/ticheng/1.png" class="image">
              <h5 style="margin-top:12px">19年3月1日之后提成上报(含线上)</h5>
            </Badge>
          </span>
        </Col>
        <Col span="2" style="text-align:center" v-show="hasCommission">
          <span class="project" @click="click('declare', 'todo', 'FQ')">
            <Badge :count="FQCount">
              <img src="/img/icons/ticheng/2.png" class="image">
              <h5 style="margin-top:12px">19年3月1日之前提成上报(仅线下)</h5>
            </Badge>
          </span>
        </Col>
        <Col span="2" style="text-align:center" v-show="hasCommission">
          <span class="project" @click="click('declare', 'todo', 'FP')">
            <Badge :count="FPCount">
              <img src="/img/icons/ticheng/3.png" class="image">
              <h5 style="margin-top:12px">提成发放申报</h5>
            </Badge>
          </span>
        </Col>
      </Row>
    </Card>
    <!-- 流程查询 -->
    <Card style="border-left:10px solid #5cadff" v-show="!viewComponent">
      <Row type="flex">
        <Col span="3">
          <h3>流程查询</h3>
        </Col>
        <Col span="2" style="text-align:center">
          <span class="project" @click="click('npform2', 'scan')">
            <img src="/img/icons/项目立项.png" class="image">
            <h5 style="margin-top:6px">项目立项</h5>
          </span>
        </Col>
        <Col span="2" style="text-align:center">
          <span class="project" @click="click('auditingFile', 'scan')">
            <img src="/img/icons/文件审核.png" class="image">
            <h5 style="margin-top:6px">文件审核</h5>
          </span>
        </Col>
        <Col span="2" style="text-align:center">
          <span class="project" @click="click('depositApplyFlow', 'scan')">
            <img src="/img/icons/退保申请.png" class="image">
            <h5 style="margin-top:6px">退保证金</h5>
          </span>
        </Col>
        <Col span="2" style="text-align:center" v-show="hasCommission">
          <span class="project" @click="click('declare', 'scan', 'QR')">
            <img src="/img/icons/ticheng/1.png" class="image">
            <h5 style="margin-top:6px">19年3月1日之后提成上报(含线上)</h5>
          </span>
        </Col>
        <Col span="2" style="text-align:center" v-show="hasCommission">
          <span class="project" @click="click('declare', 'scan', 'FQ')">
            <img src="/img/icons/ticheng/2.png" class="image">
            <h5 style="margin-top:6px">19年3月1日之前提成上报(仅线下)</h5>
          </span>
        </Col>
        <Col span="2" style="text-align:center" v-show="hasCommission">
          <span class="project" @click="click('declare', 'scan', 'FP')">
            <img src="/img/icons/ticheng/3.png" class="image">
            <h5 style="margin-top:6px">提成发放申报</h5>
          </span>
        </Col>
      </Row>
    </Card>
    <!-- 线上财务 -->
    <Card style="border-left:10px solid #5cadff" v-show="!viewComponent">
      <Row type="flex">
        <Col span="3">
          <h3>线上财务</h3>
        </Col>
        <Col span="2" style="text-align:center">
          <span class="project" @click="click('onlineCharge')">
            <Icon type="clipboard" size="38" color="#2D91F1"></Icon>
            <h5 style="margin-top:6px">线上服务费</h5>
          </span>
        </Col>
        <Col span="2" style="text-align:center">
          <span class="project" @click="click('onlineBalance')">
            <Icon type="card" size="38" color="#2D91F1"></Icon>
            <h5 style="margin-top:6px">余额确认</h5>
          </span>
        </Col>
        <Col span="2" style="text-align:center">
          <span class="project" @click="click('onlineMargin')">
            <Icon type="cash" size="38" color="#2D91F1"></Icon>
            <h5 style="margin-top:6px">线上保证金</h5>
          </span>
        </Col>
      </Row>
    </Card>
    <!-- 组件显示 -->
    <div style="height:100%;overflow:auto">
      <Button
        type="success" 
        icon="reply"
        v-show="viewComponent" 
        style="margin-bottom:10px" 
        @click="viewComponent=false">
        返回
      </Button>
      <component :is="component" v-show="viewComponent" :kind="kind" :type="this.type"></component>
    </div>
  </div>
</template>

<script>
import npform2 from './nproject/npform2'  // 立项确认 项目立项
import auditingFile from '@/views/documentation/auditingFile/auditingFile'  // 文件审核
import militaryExamine from '@/views/militaryExamine/militaryExamine'  // 保密办项目审查
import depositBackFlow from '@/views/depositBackFlow/depositBackApply'  // 退保申请
import depositApplyFlow from '@/views/depositBackFlow/depositApplyFlow'  // 退保审核
import declare from '@/views/commission/commissionSystem/declare'  // 提成
import onlineCharge from '@/views/serviceCharge/onlineCharge/onlineCharge'  // 线上服务费
import onlineBalance from '@/views/serviceCharge/onlineCharge/onlineBalance'  // 线上服务费
import onlineMargin from '@/views/serviceCharge/onlineCharge/onlineMargin' // 线上保证金

export default {
  components: {
    npform2,
    auditingFile,
    militaryExamine,
    depositBackFlow,
    depositApplyFlow,
    declare,
    onlineCharge,
    onlineBalance,
    onlineMargin
  },
  data() {
    return {
      component: '',
      viewComponent: false,
      kind: '',
      type: '',
    }
  },
  computed: {
    user () {
      return this.$store.state.session.user
    },
    editPermission() {      // 获取用户角色信息
      return this.$store.getters["session/hasRoles"]("保密办")
    },
    // 提成系统权限
    hasCommission() {
      let menu = this.$store.state.app['menuList'].filter(item => {return item.name == 'commission'})
      return menu.length > 0 ? true : false
    },
    fileCount() {
      return this.$store.state.todoCount.fileCount
    },
    depositCount() {
      return this.$store.state.todoCount.depositCount
    },
    projectCount() {
      return this.$store.state.todoCount.projectCount
    },
    secretCount() {
      return this.$store.state.todoCount.secretCount
    },
    QRCount() {
      return this.$store.state.todoCount.QRCount
    },
    FQCount() {
      return this.$store.state.todoCount.FQCount
    },
    FPCount() {
      return this.$store.state.todoCount.FPCount
    },
  },
  methods: {
    click(e, kind, type) {
      this.viewComponent = true
      this.component = e
      this.kind = kind
      this.type = type ? type : ''
    }
  }
}
</script>

<style lang="less" scoped>
.image {
  width: 32px;
  height: 32px;
}
.ivu-card {
  min-width: 1000px;
  & + .ivu-card {
    margin-top: 10px;
  }
  /deep/.ivu-card-body {
    padding: 30px 16px;
  }
  .project {
    cursor: pointer;
    display: inline-block;
    min-width: 68px;
    min-height: 68px;
    border-radius: 6px;
    padding: 4px;
    &:hover {
      background-color: rgba(92, 173, 255, 0.3)
    }
  }
  /deep/.ivu-badge-count {
    min-width: 18px;
    height: 18px;
    line-height: 18px;
    padding: 0;
    top: -6px;
  }
}
</style>
